// src/main/resources/main.js
import './tailwind.css';
import './fontAwesome/all.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Other imports
import Alpine from 'alpinejs';
import anchor from '@alpinejs/anchor' 
import morph from '@alpinejs/morph'
import mask from '@alpinejs/mask'
import intersect from '@alpinejs/intersect'
import resize from '@alpinejs/resize'
import persist from '@alpinejs/persist'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'
import sort from '@alpinejs/sort'

import htmx from 'htmx.org';
import $ from 'jquery';
import { Chart, registerables } from 'chart.js';
import { GridStack } from 'gridstack';
import 'gridstack/dist/gridstack.min.css';

// GridStack v12+ renders widget `content` as plain text by default (el.textContent) to avoid XSS.
// Our builder generates trusted markup, so render it as HTML so widget cards display correctly.
GridStack.renderCB = (el, w) => { if (el && w?.content) el.innerHTML = w.content; };

import './fontAwesome/all.min.js';

import { SystemForm } from './utils/SystemForm';
import { SystemList } from './utils/SystemList';
import { SystemAjax } from './utils/SystemAjax';
import { SystemModal } from './utils/SystemModal';
import { ApiService } from './utils/ApiService';
import { DashboardManager } from './utils/DashboardManager';
import { ReportBuilder } from './utils/ReportBuilder';
import { ReportRunManager } from './utils/ReportRunManager';
import { MenuEditor } from './utils/MenuEditor';

//import * as monaco from 'monaco-editor'; // Import Monaco Editor

// Expose globals if necessary`
window.$ = $;
window.jQuery = $;
window.htmx = htmx;
window.Alpine = Alpine;
Chart.register(...registerables);
window.Chart = Chart;
window.GridStack = GridStack;
Alpine.plugin(morph); // Register morph plugin
Alpine.plugin(anchor); // Register anchor plugin
Alpine.plugin(mask); // Register mask plugin
Alpine.plugin(intersect);
Alpine.plugin(resize);
Alpine.plugin(persist);
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(sort);
window.SystemForm = SystemForm;
window.SystemList = SystemList;
window.SystemAjax = SystemAjax;
window.SystemModal = SystemModal;
window.ApiService = ApiService;
window.DashboardManager = DashboardManager;
window.ReportBuilder = ReportBuilder;
window.ReportRunManager = ReportRunManager;

const dashboardManager = new DashboardManager(Chart);
window.dashboardManager = dashboardManager;
const reportBuilder = new ReportBuilder();
window.reportBuilder = reportBuilder;
const reportRunManager = new ReportRunManager(Chart);
window.reportRunManager = reportRunManager;
window.MenuEditor = MenuEditor;

//window.monaco = monaco; // Optionally expose monaco globally

htmx.config.refreshOnHistoryMiss = true; // Enable history miss refresh

document.addEventListener('DOMContentLoaded', () => {
  dashboardManager.initialize(document);
  reportBuilder.initialize(document);
  reportRunManager.initialize(document);
});

document.addEventListener('htmx:load', (event) => {
  dashboardManager.initialize(event.target);
  reportBuilder.initialize(event.target);
  reportRunManager.initialize(event.target);
});

document.addEventListener('htmx:beforeSwap', (event) => {
  if (event.detail && event.detail.target) {
    dashboardManager.destroyWithin(event.detail.target);
    reportRunManager.destroyWithin(event.detail.target);
  }
});

window.addEventListener('beforeunload', () => {
  dashboardManager.destroyWithin(document);
  reportRunManager.destroyWithin(document);
});

Alpine.start(); // Start AlpineJS



